document.querySelectorAll('.news-meta-share .share-link').forEach(function(element){
  element.addEventListener('click', function(event){
    event.preventDefault();
    const url = this.href;
    window.open(url, 'Share', 'width=600,height=400');
  });
});

document.querySelectorAll('.news-meta-share .share-to-clipboard').forEach(function(element){
  element.addEventListener('click', async function(event){
    event.preventDefault();
    const url = this.href;
    await navigator.clipboard.writeText(url);
    this.classList.add('share-copied');
    setTimeout(() => this.classList.remove('share-copied'), 5000);        
  });
});